import { cn } from '@/lib/cn';
import { flavorClass, type Flavor } from './flavors';

interface AvatarProps {
  flavor: Flavor;
  /** Emoji or 1–2 char initials shown inside. */
  glyph: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES = {
  sm: 'size-8 text-sm',
  md: 'size-11 text-lg',
  lg: 'size-16 text-2xl',
} as const;

/** Flavor-tinted identity chip. No photos in Nearmirer — an emoji or initials. */
export function Avatar({ flavor, glyph, size = 'md', className }: AvatarProps) {
  const c = flavorClass[flavor];
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-blob border-2 border-ink font-display font-semibold',
        c.soft,
        c.text,
        SIZES[size],
        className,
      )}
      aria-hidden
    >
      {glyph}
    </span>
  );
}
